import { createStore, createEffect } from "effector";
import { empty, getYYYYMMfromStrDate, unpackServerData } from "../../../common/functions";
import axios from "axios"
import { getUuidAndSession } from "../../../common/localStorage";
import { IQueryTransactionsResult, ITransaction, ITransactionsByMonth } from "./types";
import { getCustomUserAgent } from "../../../common/customUserAgent";

export const TransactionTypeCharge = 0 //тип транзакции "Начисление"

export const queryGetTransactions = createEffect<string, IQueryTransactionsResult>();
export const $transactions = createStore<IQueryTransactionsResult>({
  transactions: [],
  transactionsByMonth: []
})

$transactions.on(queryGetTransactions.doneData, (_, curr) => curr)


function getTransactionsByMonth(transactions: ITransaction[]): ITransactionsByMonth[] {
  let tranLen = transactions.length
  if(tranLen == 0) return []
  let tbm = [] as ITransactionsByMonth[]
  let currTran = transactions[0]
  let currAmounth = parseInt(empty(currTran.amount) ? "0" : currTran.amount)
  tbm.push({yyyymm: getYYYYMMfromStrDate(currTran.date), monthAmount: currAmounth, monthCharges: currTran.type == TransactionTypeCharge ? currAmounth : 0, monthPayments: currTran.type != TransactionTypeCharge ? currAmounth : 0})
  if(tranLen == 1){
    return tbm
  }
  let currMonth = getYYYYMMfromStrDate(currTran.date)
  for(let i = 1; i < tranLen; i++) {
    let nextTran = transactions[i]
    let nextMonth = getYYYYMMfromStrDate(nextTran.date)
    currAmounth = parseInt(empty(nextTran.amount) ? "0" : nextTran.amount)
    if(currMonth == nextMonth) {
      tbm[tbm.length-1].monthAmount += currAmounth
      if(nextTran.type == TransactionTypeCharge) tbm[tbm.length-1].monthCharges += currAmounth
      else tbm[tbm.length-1].monthPayments += currAmounth
    } else {
      tbm.push({yyyymm: nextMonth, monthAmount: currAmounth, monthCharges: nextTran.type == TransactionTypeCharge ? currAmounth : 0, monthPayments: nextTran.type != TransactionTypeCharge ? currAmounth: 0})
      currMonth = nextMonth
      currTran = nextTran
    }
  }
  return tbm
}

export function getTransactionsByYYYYMM(yyyymm: string): ITransaction[] {
  let trans = $transactions.getState().transactions
  return trans.filter((e) => getYYYYMMfromStrDate(e.date) == yyyymm)
}

export function getPaymentsByYYYYMM(yyyymm: string): ITransaction[] {
  let trans = $transactions.getState().transactions
  return trans.filter((e) => getYYYYMMfromStrDate(e.date) == yyyymm && e.type != TransactionTypeCharge)
}

export function getChargesByYYYYMM(yyyymm: string): ITransaction[] {
  let trans = $transactions.getState().transactions
  return trans.filter((e) => getYYYYMMfromStrDate(e.date) == yyyymm && e.type == TransactionTypeCharge)
}



queryGetTransactions.use((accountId) =>
  axios.post("https://izba.kras-abs.ru/api/v3/transaction/payments", {
    ...getUuidAndSession(),
    accountId: accountId,
    },{
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        "Custom-User-Agent": getCustomUserAgent()
      }
    }).then((resp) => {
      let data = unpackServerData(resp.data, "getTransactions.transactions")      
      // if(data.failMsg != '') {
        return {transactions: data.data.transactions as ITransaction[], transactionsByMonth: getTransactionsByMonth(data.data.transactions)} as IQueryTransactionsResult
      // }
      // return {transactions: [], transactionsByMonth: []} as IQueryTransactionsResult
    }).catch(e => {
      let msg = e.message
      if(e.response && e.response.data) {
        let data = unpackServerData(e.response.data)
        if(data.failMsg != "") {
          msg = data.failMsg
        }
      }
      return {transactions: [], transactionsByMonth: []} as IQueryTransactionsResult
    })
);